import axios from "axios";
import api from "@/plugins/api";
/**
 * Fetches the current user's subscription view preferences from the BFF.
 * Returns null when none have been recorded yet (BFF responds 404).
 */
export async function getSubscriptionViews() {
    try {
        const response = await api.get("/subscription-views", {
            unwrapEnvelope: true,
        });
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
            return null;
        }
        throw error;
    }
}
/** Persists the current user's subscription view preferences via the BFF. */
export async function saveSubscriptionViews(prefs) {
    await api.put("/subscription-views", prefs, {
        unwrapEnvelope: true,
    });
}
